import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from '../../../utils/hooks/useDateService';
import useFieldHelper from '../fieldHelper';
import TextField from '../text/TextField';
import { FieldProps } from '../types';

const FormattedDateField = ({ format = DATE_FORMAT.SIMPLE, noWrap = false, ...props }: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  return (
    <TextField
      label={getLabel()}
      value={
        getValue() ? (
          <ShowDate
            dateUTC={getValue()}
            format={format}
            isDateTime={false}
            sx={noWrap ? { whiteSpace: 'nowrap !important' } : undefined}
          />
        ) : null
      }
    />
  );
};

export default FormattedDateField;
